// src/components/Product/ProductCard/ColorSelector.js
import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';

const ColorSelector = ({ 
  productColors, 
  selectedColorIndex, 
  onColorChange 
}) => {
  if (productColors.length === 0) return null;

  return (
    <Box sx={{ mb: 4, width: '100%' }}>
      <Typography 
        variant="subtitle1" 
        sx={{ 
          mb: 1,
          fontWeight: 'bold',
          color: '#333',
          textAlign: 'right'
        }}
      >
        اللون: {productColors[selectedColorIndex]?.colors?.name || productColors[selectedColorIndex]?.color || ''}
      </Typography>
      
      <Box sx={{ 
        display: 'flex', 
        gap: 1.5, 
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        flexDirection: 'row',
        width: '100%',
        mt: 1
      }}>
        {productColors.map((colorItem, index) => (
          <Box
            key={colorItem.id}
            onClick={() => onColorChange(index)}
            sx={{
              cursor: 'pointer',
              transition: 'transform 0.2s ease',
              '&:hover': { transform: 'scale(1.1)' }
            }}
          >
            <Avatar
              sx={{
                width: 48,
                height: 48,
                border: selectedColorIndex === index 
                  ? '3px solid #0f3662' 
                  : '2px solid #e0e0e0',
                boxShadow: selectedColorIndex === index 
                  ? '0 0 0 2px rgba(15, 54, 98, 0.2)' 
                  : 'none',
                backgroundColor: '#f5f5f5'
              }}
              src={colorItem.product_color_images?.[0]?.image_url}
              alt={colorItem.colors?.name || colorItem.color}
            >
              {!colorItem.product_color_images?.[0]?.image_url && 
                (colorItem.colors?.name?.[0] || colorItem.color?.[0])}
            </Avatar>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ColorSelector;
